<template>
  <div class="container pt-3 pb-1 step-2">
    <div class="row">
      <div class="col-12">
        <p class="lora h3">Dane rezerwującego</p>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-8 order-1 order-md-0 h-100">
        <div class="md-left">
          <div class="white-panel">
            <div class="row">
              <div class="col-10 offset-1">
                <form action>
                  <div class="row">
                    <WInput class="col-12" :model="schema.customer.name" />

                    <WInput class="col-6" :model="schema.customer.email" />

                    <WInput class="col-6" :model="schema.customer.phone" />
                  </div>

                  <WCheckbox :model="schema.wantInvoice" />

                  <div v-if="schema.wantInvoice.$model" class="row">
                    <hr />
                    <p class="h4 lora w-100">Dane do faktury</p>

                    <WInput class="col-12" :model="schema.invoice.name" />

                    <WInput class="col-4" :model="schema.invoice.nip" />

                    <WInput class="col-8" :model="schema.invoice.street" />

                    <WInput class="col-7" :model="schema.invoice.city" />

                    <WInput class="col-5" :model="schema.invoice.postalCode" />

                    <hr />
                  </div>

                  <div class="row">
                    <hr class="w-100" />
                    <p class="w-100">
                      <WTextarea class="label-h4" :model="schema.customerNotes" />
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-4 order-0 order-md-1 h-100">
        <div class="md-right">
          <SmallSummary :schema="schema" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WCheckbox from '@witkac/bootstrap4-components/src/components/checkbox';
import WInput from '@witkac/bootstrap4-components/src/components/input';
import WTextarea from '@witkac/bootstrap4-components/src/components/textarea';

import SmallSummary from './SmallSummary';

export default {
  components: { SmallSummary, WCheckbox, WInput, WTextarea },
  props: {
    schema: { type: Object, required: true },
    settings: { type: Object, required: true }
  }
};
</script>

<style></style>
